module.exports = __webpack_public_path__ + "img/slider_1.057318d5.jpg";